"use strict";
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsToNDJSON = eventsToNDJSON;
/**
 * Converts an array of events to a single ndjson string.
 * @param events An array of events {@link Event}
 */
function eventsToNDJSON(events) {
    return "".concat(events.map(function (event) { return JSON.stringify(event); }).join('\n'), "\n");
}
